import React, {Component} from 'react';
import {Row, Col, Button, Fa} from "mdbreact";
import {API_URL} from "../../config/Config";

export default class ProductComplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            price:0,
            quantity:1,
        };
    }

    render() {
        const { productObj } = this.props;

        return (
            <div className="product-list-item mb-5">

                <Row>
                    <Col sm="12" md="4" >
                        <img src={API_URL+productObj.pic} alt={productObj.title} className="w-100"/>

                        <div className="clearfix m-4">
                            <select className="browser-default  p-1 border-dark w-100 text-center" onChange={e => this.setState({ quantity: e.target.value })} value={this.state.quantity}>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </select>
                        </div>
                    </Col>
                    <Col sm="12" md="8" >
                        <Row>
                            <div className="d-flex justify-content-end  w-100 pl-0" >
                                {productObj.specialOffer ? <div><div className="text-white primary-color-dark product-item-lables">پیشنهاد ویژه</div></div>: ""}
                                {productObj.discountAmount !==0 ? <div><div className="text-white danger-color-dark product-item-lables">{productObj.discountAmount} ریال </div></div>: ""}
                            </div>
                        </Row>
                        <Row className="mb-5">
                            <Col md="8" sm='12' className="pr-0">
                                <h2 className="mt-5">{productObj.title}</h2>
                            </Col>
                            <Col md="4" sm='12' className="pl-0">
                                <div className="text-left" >
                                    <p><span className="oldPrice ng-binding">{productObj.priceOld} ریال<span className="cross-price" style={{backgroundColor: "#0092cf"}}/></span></p>
                                    <p><span className="newPrice"><span className="price ng-binding">{productObj.price}</span> <span className="currancy"> ریال</span> </span></p>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <p className="text-justify">{productObj.description}</p>
                        </Row>

                        <Row className="mt-5">
                            <Col md="6" sm="12"/>
                            <Col md="6" sm="12" className="text-center">
                                <Button outline block color="info" className="product-add-to-cart"><Fa icon="shopping-cart" className="mr-1"/> خرید {productObj.price} ریال</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>



            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/product/ProductComplate.js